<sdc-bo-dialog
  headerTitle="Are you sure you want to delete this discount code?"
  [styleClass]="['variant-prominent-title']"
  [attr.data-cy]="'discount-delete-modal-' + data?.id">
  <div class="content-wrapper">
    <div>
      <div class="input-line">
        <div>
          <span><b>Code</b></span>
        </div>
        <div>
          <p>{{ data?.code }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Description</b></span>
        </div>
        <div>
          <p>{{ data?.description }}</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Discount %</b></span>
        </div>
        <div>
          <p>{{ data?.discountPercentage }}%</p>
        </div>
      </div>
      <div class="input-line">
        <div>
          <span><b>Enabled</b></span>
        </div>
        <div>
          <p>{{ data?.enabled ? 'Yes' : 'No' }}</p>
        </div>
      </div>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button
      [attr.data-cy]="'discount-delete-modal-cancel-button-' + data?.id"
      variant="secondary"
      (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button
      [attr.data-cy]="'discount-delete-modal-confirm-button-' + data?.id"
      variant="destructive"
      (onClick)="onConfirm(data?.id)">
      Permanently delete
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
